import { Systems } from "@/fhir/enums/systems";

/** Repeating Patient Co-pay / Co-insurance groups on the benefits verification questionnaire. */
export const CLIENT_COPAY_ENTRIES_LINK_ID = "clientCopayEntries";
export const CLIENT_COPAY_ENTRIES_FORMSET_CODE_LINK_ID = "clientCopayEntriesFormsetCode";
export const COPAY_CARE_TYPE_LINK_ID = "copayCareType";
export const COPAY_AMOUNT_LINK_ID = "copayAmount";
export const COPAY_NOTES_LINK_ID = "copayNotes";

export const CLIENT_COINSURANCE_ENTRIES_LINK_ID = "clientCoinsuranceEntries";
export const CLIENT_COINSURANCE_ENTRIES_FORMSET_CODE_LINK_ID =
  "clientCoinsuranceEntriesFormsetCode";
export const COINSURANCE_CARE_TYPE_LINK_ID = "coinsuranceCareType";
export const COINSURANCE_PERCENT_LINK_ID = "coinsurancePercent";
export const COINSURANCE_NOTES_LINK_ID = "coinsuranceNotes";

export const REIMBURSEMENT_RATE_LINK_ID = "reimbursementRate";

/** Singular copay and coinsurance answers on older QuestionnaireResponses and the current Verify UI. */
export const LEGACY_CLIENT_COPAY_LINK_ID = "clientCopay";
export const LEGACY_CLIENT_COINSURANCE_LINK_ID = "clientCoinsurance";

export const COVERAGE_CARE_TYPE_VALUES = ["Prenatal", "Home Birth", "Birth Center"] as const;

export const COVERAGE_CARE_TYPE_OPTIONS = COVERAGE_CARE_TYPE_VALUES.map((value) => ({
  value,
  label: value,
}));

export type CoverageCareType = (typeof COVERAGE_CARE_TYPE_VALUES)[number];

/** Written on `Coverage.costToBeneficiary.type` by the insurance-coverage bot. */
export const COVERAGE_COST_TYPE_SYSTEM = `${Systems.QH}/fhir/CodeSystem/coverage-cost-type`;

/** Written on `Coverage.costToBeneficiary.exception.type` for care-type-scoped rows. */
export const COVERAGE_CARE_TYPE_SYSTEM = `${Systems.QH}/fhir/CodeSystem/coverage-care-type`;

export const COVERAGE_CARE_TYPE_CODES = {
  Prenatal: "prenatal",
  "Home Birth": "home-birth",
  "Birth Center": "birth-center",
} as const satisfies Record<CoverageCareType, string>;

export const COVERAGE_COST_TYPE = {
  copay: { code: "copay", display: "Copay" },
  coinsurance: { code: "coinsurance", display: "Coinsurance" },
  deductible: { code: "deductible", display: "Individual Annual Deductible" },
  individualOopMax: { code: "individual-oop-max", display: "Individual Out-of-Pocket Max" },
  familyDeductible: { code: "family-deductible", display: "Family Annual Deductible" },
  familyOopMax: { code: "family-oop-max", display: "Family Out-of-Pocket Max" },
  reimbursementRate: { code: "reimbursement-rate", display: "Reimbursement Rate" },
} as const;
